import React from 'react';
import GxList from '../../gx/GxList';
import CxLink from '../../cx/CxLink';
import GxDlgSelectAnimal from '../../gx/GxDlgSelectAnimal';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxDat from '../../fx/FxDat';
import * as FxTable from '../../fx/FxTable';
import { isApp } from '../../gx/GxStore';
import { useWindowSize } from '../../hx/useWindowSize';
import { useTranslation } from '../../hx/useTranslation';
import { getStoreValue, } from "../../gx/GxStore";

const MxAppointmentListCP = (props) => {
  const [{ trans }] = useTranslation();
  const size = useWindowSize();
  
  const r_list = React.useRef(null);
  const r_dlg_select_animal = React.useRef(null);

  const lang = getStoreValue('StoreSession', 'txLocale').substring(0,2);
  const app = getStoreValue('StoreSession', 'txApp');
  const idi = getStoreValue('StoreSession', 'txIdi');
  const cy = encodeURIComponent(getStoreValue('StoreSession', 'txCompany'));
  const inClient = getStoreValue('StoreSession', 'inClientCP');

  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const getTableColumns = () => {
    let cols = [];
    try{
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "inCalendar", show: false });
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: id++, Header: trans('field.date'), accessor: row => (FxTable.cellToLocalDateTime(row["dtFrom"])), width: '20%' });
        if (isApp('vett') || isApp('spaw')) {
          cols.push({id: id++, Header: trans('field.patient'), accessor: "txAnimal", width: '20%'});
        }
        cols.push({ id: id++, Header: trans('field.issue'), accessor: "txRemarks", width: '60%' });

      } else { // PANTALLA PEQUEÑA
        cols.push({ id: id++, Header: trans('field.date'), accessor: row => (FxTable.cellToLocalDateTime(row["dtFrom"])), width: '40%' });
        if (isApp('vett') || isApp('spaw')) {
          cols.push({id: id++, Header: trans('field.patient'), accessor: "txAnimal", width: '25%'});
        }
        cols.push({ id: id++, Header: trans('field.issue'), accessor: "txRemarks", width: '35%' });
      }

      cols.push({ id: "A", Header: "inactive", accessor: row => FxDat.isExpired(row["dtFrom"]), show: false });

    } catch(error) {
      FxLog.errorx('MxAppointmentListCP.getTableColumns', error)
    }
    return cols;
  }

  const openOla = (rowAnimal) => {
    // construye url
    const baseUrl = window.location.origin;
    let url = '';
    if (rowAnimal) {
      url = `${baseUrl}/ola?lang=${lang}&app=${app}&idi=${idi}&cy=${cy}&inClient=${inClient}&inAnimal=${rowAnimal.inAnimal}`;
    } else {
      url = `${baseUrl}/ola?lang=${lang}&app=${app}&idi=${idi}&cy=${cy}&inClient=${inClient}`;
    }
    FxLog.infox('MxAppointmentListCP.openOla', '...url:', url);
    window.open(url, "_blank");
  }

  return (
    <div>
      <GxList
        moduleName={trans('field.my_x','field.appointments')}
        xref={r_list}
        fullscreen
        hasSearchBox={false}
        hasButtonAdd={false}
        url="cp/appointments"
        filter={`n_calendar.inClient='${getStoreValue('StoreSession', 'inClientCP')}'`}
        /* onOpenForm={openForm} */
        refColors={ [ 
          'table_cell_color_gray|' + trans('field.past_0'), 
        ] }
        columns={getTableColumns()}
        disabled={true}
      />

      <CxLink
        label={`[${trans('field.request_appointment_online').toUpperCase()}]`}
        style={{ margin: '0 0 0 1px', fontSize: '14px' }}
        onClick={() => {
          if (isApp('vett') || isApp('spaw')) {
            r_dlg_select_animal.current.setOpen(true);
          } else {
            openOla();
          }
        }}
      />

      <GxDlgSelectAnimal
        xref={r_dlg_select_animal}
        inClient={inClient}
        onSelect={(row) => {
          //console.log('Animal seleccionado:', row.original);
          openOla(row.original);
        }}
      />

    </div>
  );

}

export default MxAppointmentListCP;
